import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=c75696d0&scoped=true"
import script from "./handle.vue?vue&type=script&lang=js"
export * from "./handle.vue?vue&type=script&lang=js"
import style0 from "./handle.vue?vue&type=style&index=0&id=c75696d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75696d0",
  null
  
)

export default component.exports